import { render, staticRenderFns } from "./CoinInformation.vue?vue&type=template&id=7a5aea97&scoped=true"
import script from "./CoinInformation.vue?vue&type=script&lang=js"
export * from "./CoinInformation.vue?vue&type=script&lang=js"
import style0 from "./CoinInformation.vue?vue&type=style&index=0&id=7a5aea97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5aea97",
  null
  
)

export default component.exports